import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Courses from "@/pages/Courses";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import CertificateVerifier from "@/pages/CertificateVerifier";
import Notes from "@/pages/Notes";
import Admin from "@/pages/Admin";
import CourseDetail from "@/pages/CourseDetail";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import { getOrganizationSchema, getEducationalOrganizationSchema, getWebsiteSchema } from "@/components/schema";

function App() {
  const orgJson = JSON.stringify(getOrganizationSchema());
  const eduJson = JSON.stringify(getEducationalOrganizationSchema());
  const siteJson = JSON.stringify(getWebsiteSchema());
  return (
    <HelmetProvider>
      <div className="App">
        <Helmet>
          <script type="application/ld+json">{orgJson}</script>
          <script type="application/ld+json">{eduJson}</script>
          <script type="application/ld+json">{siteJson}</script>
        </Helmet>
        <BrowserRouter>
          <Navbar />
          <FloatingButtons />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:slug" element={<CourseDetail />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/verify" element={<CertificateVerifier />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
